import {
	Box,
	Flex,
	Heading,
	Image,
	Text,
	Stack,
	StackDivider,
	useColorModeValue
} from '@chakra-ui/react';
import { ListingModel } from 'models/Listing/Listing';
import { MarketTooltipData } from '../types';
import { TooltipProps } from 'recharts';

interface MarketListingTooltipProps extends TooltipProps<number, string> {
	listings?: ListingModel[];
}

const MarketListingTooltip = ({ active, payload, label, listings }: MarketListingTooltipProps) => {
	const bgColor = useColorModeValue('white', 'navy.800');
	const textColor = useColorModeValue('secondaryGray.900', 'white');
	const textColorSecondary = useColorModeValue('secondaryGray.600', 'white');
	const borderColor = useColorModeValue('gray.200', 'whiteAlpha.200');

	if (!active || !payload || !payload.length || !listings) {
		return null;
	}

	const data = payload[0].payload;

	return (
		<Box
			bg={bgColor}
			p={4}
			borderRadius="lg"
			boxShadow="lg"
			border="1px solid"
			borderColor={borderColor}
		>
			<Stack spacing={3}>
				<Box>
					<Text color={textColorSecondary} fontSize="sm">
						Date
					</Text>
					<Heading size="sm" color={textColor}>
						{label}
					</Heading>
				</Box>
				<StackDivider />
				<Box>
					<Text color={textColorSecondary} fontSize="sm">
						Listings
					</Text>
					<Heading size="sm" color={textColor}>
						{listings.length}
					</Heading>
				</Box>
				{data.percentage && (
					<Box>
						<Text color={textColorSecondary} fontSize="sm">
							Change
						</Text>
						<Heading size="sm" color={data.percentage >= 0 ? 'green.500' : 'red.500'}>
							{data.percentage}%
						</Heading>
					</Box>
				)}
			</Stack>
		</Box>
	);
};

export default MarketListingTooltip;
